module.exports = __webpack_public_path__ + "static/media/shelf.79b7e197.png";